// Configuration for external services
export const NEXTAUTH_API_URL = process.env.NEXTAUTH_API_URL;
export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:3002";

/**
 * Whether toast notifications are shown. Toasts are development-only by default
 * (visible when NODE_ENV !== "production", i.e. under `next dev`). Set
 * NEXT_PUBLIC_ENABLE_TOASTS to "true" or "false" to override per environment —
 * e.g. enable in a staging build or temporarily in prod. The value is inlined
 * at build time, so it's read once per build, not at runtime.
 *
 * Precedence: explicit "true" → on, explicit "false" → off, unset → dev-only.
 */
export const TOASTS_ENABLED =
  process.env.NEXT_PUBLIC_ENABLE_TOASTS === "true" ||
  (process.env.NEXT_PUBLIC_ENABLE_TOASTS !== "false" &&
    process.env.NODE_ENV !== "production");
